import { Box, Divider } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SolidGradientColorPicker from "../../../../../../../components/common/SolidGradientColorPicker/SolidGradientColorPicker";
import { useAppStore } from "../../../../../../../hooks/useStores";
import useDesignEditorUtils, { FeatureType, Property } from "../../../../../../CustomUtils/UseDesignEditor";
import MainTabHeader from "../../../../../../components/common/MainTabHeader/MainTabHeader";
import { useActiveObject } from "../../../../../../hooks/useActiveObject";
import UseBrandConfigs from "../../../../../../hooks/useBrandConfigs.tsx";
import { useEditor } from "../../../../../../hooks/useEditor";
import { LayerType } from "../../../../../../types";
import SelectedBrandColors from "../Common/SelectedBrandColors/SelectedBrandColors.tsx";
import styles from "./StrokeColor.module.scss";

const StrokeColor = () => {
	const { t } = useTranslation("translation", { keyPrefix: "editor.tabs" });
	const { campaignStore } = useAppStore();
	const activeObject = useActiveObject() as any;
	const [color, setColor] = useState(activeObject?.stroke ?? "#000");
	const { EditAllAds, getRgbAndOpacityFromRgba, updateColorOpacity } = useDesignEditorUtils();
	const editor = useEditor();
	const { modifyActiveObjectProperty } = UseBrandConfigs();
	const isFabricShape =
		activeObject?.type === LayerType.STATIC_RECT ||
		activeObject?.type === LayerType.STATIC_CIRCLE ||
		activeObject?.type === LayerType.STATIC_TRIANGLE;

	useEffect(() => {
		if (activeObject?.stroke) setColor(updateColorOpacity(activeObject.stroke, activeObject.opacity));
	}, [activeObject]);

	const changeBackgroundColor = (color: string, brandColor: boolean = false) => {
		if (isFabricShape) {
			const result = getRgbAndOpacityFromRgba(color);
			editor?.objects.update(
				{
					stroke: color,
					opacity: brandColor ? undefined : (result?.opacity ?? 1),
					brandId: undefined,
				},
				undefined,
				!campaignStore.isEditingAllAds,
			);
			EditAllAds(activeObject?.type, activeObject?.shapeType, FeatureType.STROKE, result?.rgb ?? color);
		}
	};

	return (
		<>
			<Box className={styles.container}>
				<MainTabHeader title={t("strokeColor")} />
				<Box className={`${styles.tabs} ${styles.fullHeight}`}>
					<Box className={styles.ColorFillContent}>
						<Box className={styles.colorPickerContainer}>
							<SolidGradientColorPicker
								color={color}
								onChange={(color: string) => {
									setColor(color);
									changeBackgroundColor(color);
									modifyActiveObjectProperty(activeObject, Property.STOKE_COLOR_NUMBER, undefined);
								}}
								hideColorTypeBtns={true}
							/>
						</Box>
						<Divider className={styles.mainDivider} />
						<SelectedBrandColors
							activeObject={activeObject}
							updateColor={(color: string) => {
								setColor(color);
								changeBackgroundColor(color, true);
							}}
							property={Property.STOKE_COLOR_NUMBER}
						/>
					</Box>
				</Box>
			</Box>
		</>
	);
};

const ObservedComponent = observer(StrokeColor);
export default ObservedComponent;
